import * as React from 'react';
import * as styles from './styles.css';

export interface IFeatureCard {
  title: string;
  linkText: string;
  image: string;
  cardType: 'candidate' | 'quality';
}

export interface IFeaturesSectionProps {
  features: IFeatureCard[];
  onCardClick: (cardType: 'candidate' | 'quality') => void;
}

export const FeaturesSection: React.FC<IFeaturesSectionProps> = ({ features, onCardClick }) => (
  <section className={styles['features-section']} aria-label="Возможности">
    <div className={styles['features']}>
      <div className={styles['features__header']}>
        <h2 className={`${styles['features__title']} text-primary`}>Кто будет с вами работать</h2>
      </div>
      <p className={`${styles['features__subtitle']} body1`}>Опытные агенты с гарантией качества от Циана</p>
      <div className={styles['features__cards']}>
        {features.map(feature => (
          <article
            key={feature.title}
            className={styles['feature-card']}
            role="button"
            tabIndex={0}
            onClick={() => onCardClick(feature.cardType)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onCardClick(feature.cardType);
              }
            }}
            data-modal-open
          >
            <div className={styles['feature-card__content']}>
              <h4 className="text-primary">{feature.title}</h4>
              <p className={`${styles['feature-card__link']} body1`}>{feature.linkText}</p>
            </div>
            <img className={styles['feature-card__image']} src={feature.image} alt="" />
          </article>
        ))}
      </div>
    </div>
  </section>
);
